import React, { useState, useEffect } from 'react';
import { Container, Button } from 'react-bootstrap';
import { getAuth } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { FaCoins, FaRegHandshake } from 'react-icons/fa';
import NavbarComponent from '../components/NavbarComponent';
import FooterComponent from '../components/FooterComponent';
import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

const CoinIcon = styled(FaCoins)`
  font-size: 50px;
  color: #FFB800;
  animation: ${bounce} 1.5s infinite ease-in-out;
`;

const WelcomePage = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (currentUser) {
      setUser(currentUser);
    }
  }, []);

  return (
    <>
      <NavbarComponent />

      <Container className="text-center my-5">

        {/* ✅ Headline */}
        <h2 style={{ fontSize: '30px', fontWeight: 'bold', color: '#FF7C24' }}>
          Welcome to Fintorro Community! 🚀
        </h2>

        {/* ✅ Subtext */}
        <p style={{
          fontSize: '16px',
          color: '#232830',
          fontWeight: '500',
          marginTop: '10px',
          padding: '0 20px'
        }}>
          ✨ Ready to level up your trading and investing game? 🚀💰 <br /><br />
          Meet your <strong>AI tutor</strong> – your personal guide to making smart trading and investing moves!
        </p>

        {/* ✅ Handshake Icon */}
        <div className="my-3">
          <FaRegHandshake style={{ fontSize: '50px', color: '#2ECC71' }} />
        </div>

        {/* ✅ YouTube Video Embed */}
        <div style={{
          margin: '30px 0',
          maxWidth: '560px',
          width: '100%',
          aspectRatio: '16 / 9',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}>
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/eH_WNyWo6Hg?autoplay=1&mute=1&controls=1&rel=0"
            title="Fintorro Welcome Video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        </div>

        {/* ✅ Let's Go Button */}
        <Button
          onClick={() => navigate('/amm')}
          style={{
            backgroundColor: '#FF7C24',
            borderColor: '#FF7C24',
            fontSize: '18px',
            fontWeight: 'bold',
            borderRadius: '10px',
            padding: '12px 30px',
            marginTop: '15px',
          }}
        >
          Let's Go! 🚀
        </Button>
      </Container>

      <FooterComponent />
    </>
  );
};

export default WelcomePage;







// import React, { useState, useEffect } from 'react';
// import { getFirestore, collection, getDocs, query, where } from 'firebase/firestore';
// import { Container, Row, Col, Card, Button } from 'react-bootstrap';
// import { getAuth } from 'firebase/auth';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { FaBookOpen, FaFire, FaBitcoin, FaChartBar } from 'react-icons/fa'; // Import Book Icon
// import Layout from './Logout';
// import { Offcanvas } from 'react-bootstrap';


// const WelcomePage = () => {
//   const [user, setUser] = useState(null);
//   const [showWelcomeNote, setShowWelcomeNote] = useState(true);
//   const [showStartLearning, setShowStartLearning] = useState(true);
//   const [showCourses, setShowCourses] = useState(false);
//   const [showChapters, setShowChapters] = useState(false);
//   const [courses, setCourses] = useState([]);
//   const [chapters, setChapters] = useState([]);
//   const [topics, setTopics] = useState([]);
//   const [unitLessons, setUnitLessons] = useState({});
//   const [selectedCourse, setSelectedCourse] = useState(null);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [showLearningContent, setShowLearningContent] = useState(false);
//   const [learningContent, setLearningContent] = useState({});
//   const [totalTokens, setTotalTokens] = useState(0);
//   const [totalStreak, setTotalStreak] = useState(0);
//   const [insightCount, setInsightCount] = useState(5);


//   const db = getFirestore();

//   // Fetch logged-in user
//   useEffect(() => {
//     const auth = getAuth();
//     const currentUser = auth.currentUser;
//     if (currentUser) {
//       setUser(currentUser);
//       setShowWelcomeNote(true);
//     }
//   }, []);

//   // Fetch courses dynamically
//   useEffect(() => {
//     const fetchCourses = async () => {
//       const snapshot = await getDocs(collection(db, 'courses_new'));
//       const fetchedCourses = snapshot.docs.map((doc) => doc.data());
//       setCourses(fetchedCourses);
//     };
//     fetchCourses();
//   }, []);

//   // Fetch topics dynamically
//   useEffect(() => {
//     const fetchTopics = async () => {
//       const snapshot = await getDocs(collection(db, 'topics_new'));
    
//       const fetchedTopics = snapshot.docs
//         .map((doc) => doc.data())
//         .sort((a, b) => a.chapterid.localeCompare(b.chapterid) || a.topicid.localeCompare(b.topicid)); // Sorting by chapter and topic IDs
    
//       setTopics(fetchedTopics);
//     };
    
//     fetchTopics();
//   }, []);

//   // Fetch unit-based lesson IDs dynamically
//   useEffect(() => {
//     const fetchUnitLessons = async () => {
//       const snapshot = await getDocs(collection(db, 'units_new'));
    
//       const fetchedUnits = snapshot.docs
//         .map((doc) => doc.data())
//         .sort((a, b) => a.topicid.localeCompare(b.topicid) || a.lessonid.localeCompare(b.lessonid)); // Sorting by topic and lesson IDs
    
//       const unitLessonsByTopic = {};
//       fetchedUnits.forEach((unit) => {
//         if (!unitLessonsByTopic[unit.topicid]) {
//           unitLessonsByTopic[unit.topicid] = [];
//         }
//         unitLessonsByTopic[unit.topicid].push(unit.lessonid);
//       });
    
//       setUnitLessons(unitLessonsByTopic);
    
//     };
//     fetchUnitLessons();
//   }, []);

//   // Handle course selection or state restoration
//   useEffect(() => {
//     const state = location.state;
    
//     if (state && state.showLessonsDirectly) {
//       setShowWelcomeNote(false);
//       setShowStartLearning(false);
//       setShowCourses(false);
//       setShowChapters(true);
  
//       // ✅ Restore selectedCourse if it exists
//       if (state.selectedCourse) {
//         setSelectedCourse(state.selectedCourse);
        
//         // ✅ Trigger fetching chapters to ensure they appear
//         handleCourseSelection(state.selectedCourse);
//       }
//     }
//   }, [location.state]);  // ✅ Add location.state as dependency
  
  
  
  

//   const handleCourseSelection = async (course) => {
//     setShowWelcomeNote(false);
//     setSelectedCourse(course);
//     setShowCourses(false);
//     setShowStartLearning(false);
//     setShowChapters(true);
  
//     try {
//       const chaptersCollection = collection(db, 'chapters_new');
//       const chaptersSnapshot = await getDocs(chaptersCollection);
  
//       const fetchedChapters = chaptersSnapshot.docs
//         .map((doc) => doc.data())
//         .filter((chapter) => chapter.courseid === course.courseid)
//         .sort((a, b) => a.chapterid.localeCompare(b.chapterid));
  
//       setChapters(fetchedChapters);
//     } catch (error) {
//       console.error("❌ Error fetching chapters:", error);
//     }
//   };
  
  

//   const handleStartLearning = () => {
//     setShowWelcomeNote(false);
//     setShowStartLearning(false);
//     setShowCourses(true);
//   };
//   const handleLessonClick = (lessonId) => {
//     let incorrectAnswers = parseInt(localStorage.getItem('incorrectAnswerCount')) || 0;
  
//     if (incorrectAnswers >= 5) {
//       alert("You've reached your daily incorrect answer limit. Upgrade to Fintorro Pro to continue.");
//       navigate('/pro-subscription');
//       return;
//     }
  
//     navigate('/quiz', { state: { selectedCourse, lessonId } });
//   };
  
  

//   // Function to generate quiz-based lesson IDs
//   const generateQuizLessons = (unitLessonId) => {
//     if (unitLessonId.endsWith('.0')) {
//       const baseLessonId = unitLessonId.replace('.0', '');
//       return Array.from({ length: 13 }, (_, i) => `${baseLessonId}.${i + 1}`);
//     }
//     return [];
//   };
//   // ⬇️ ADD THIS FUNCTION BELOW generateQuizLessons() ⬇️
//   const handleShowLearningContent = async (topicId) => { 
//     setShowLearningContent(true);
//     setLearningContent({ actions: 'Loading...', contentitems: 'Loading...', protips: 'Loading...' });
  
//     const q = query(collection(db, 'learningcontent_new'), where('topicid', '==', topicId));
//     const snapshot = await getDocs(q);
  
//     if (!snapshot.empty) {
//       const data = snapshot.docs[0].data(); // Assuming one document per topic
//       setLearningContent(data);
//     } else {
//       setLearningContent({ actions: 'No data available', contentitems: 'No data available', protips: 'No data available' });
//     }
//   };
//   // Global black background styling
//   useEffect(() => {
//     document.body.style.backgroundColor = '#000';
//     document.body.style.color = '#fff';
//     return () => {
//       document.body.style.backgroundColor = '';
//       document.body.style.color = '';
//     };
//   }, []);
//   useEffect(() => {
//     const fetchUserStats = async () => {
//       const auth = getAuth();
//       const currentUser = auth.currentUser;
  
//       if (currentUser) {
//         const db = getFirestore();
  
//         // Fetch Tokens
//         const tokensQuery = query(
//           collection(db, 'usertotaltokens'),
//           where('userid', '==', currentUser.uid)
//         );
//         const tokensSnapshot = await getDocs(tokensQuery);
//         let tokensTotal = 0;
//         tokensSnapshot.forEach((doc) => {
//           tokensTotal += doc.data().totaltokens;
//         });
//         setTotalTokens(Number(tokensTotal));  // Ensure tokens are numbers
  
//         // Fetch Streak
//         const streakQuery = query(
//           collection(db, 'userstreaktotal'),
//           where('userid', '==', currentUser.uid)
//         );
//         const streakSnapshot = await getDocs(streakQuery);
//         let streakTotal = 0;
//         streakSnapshot.forEach((doc) => {
//           streakTotal += doc.data().totalstreakcount;
//         });
//         setTotalStreak(Number(streakTotal));  // Ensure streaks are numbers
//       }
//     };
  
//     const checkIncorrectAnswers = () => {
//       let incorrectAnswers = parseInt(localStorage.getItem('incorrectAnswerCount')) || 0;
//       let lastAttemptTimestamp = parseInt(localStorage.getItem('lastAttemptTimestamp')) || 0;
//       let currentTimestamp = Date.now();
  
//       // Reset incorrect answer count if 24 hours have passed
//       if (lastAttemptTimestamp && (currentTimestamp - lastAttemptTimestamp > 24 * 60 * 60 * 1000)) {
//         localStorage.setItem('incorrectAnswerCount', '0');  // Reset to 0
//         incorrectAnswers = 0;
//       }
  
//       // Update Insight (📊) count dynamically
//       setInsightCount(5 - incorrectAnswers);
  
//       // If the user has exhausted their incorrect answers, block quiz access
//       if (incorrectAnswers >= 5) {
//         alert("You've reached your daily incorrect answer limit. Upgrade to Fintorro Pro to continue.");
//         navigate('/pro-subscription');
//       }
//     };
  
//     fetchUserStats();
//     checkIncorrectAnswers();  // ✅ Runs when the component loads
  
//   }, [navigate]);  // ✅ Dependencies include `navigate`
  
  

//   return (
//     <Layout>
//       <Container className="text-center">
//         {/* Welcome Note */}
//         {user && showWelcomeNote && (
//           <div className="my-4">
//             <h2>Welcome, {user.email}!</h2>
//           </div>
//         )}

//         {/* Start Learning Button */}
//         {showStartLearning && (
//           <Button
//             className="mt-4"
//             onClick={handleStartLearning}
//             style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24' }}
//           >
//             Start Learning
//           </Button>
//         )}

//         {/* Course Selection */}
//         {showCourses && (
//           <div className="mt-5">
//             <h3>Select a course:</h3>
//             <Row className="mt-4 justify-content-center">
//               {courses.map((course) => (
//                 <Col key={course.courseid} xs={12} sm={6} md={4} className="mb-3">
//                   <Button
//                     onClick={() => handleCourseSelection(course)}
//                     style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24', width: '100%' }}
//                   >
//                     {course.coursename}
//                   </Button>
//                 </Col>
//               ))}
//             </Row>
//           </div>
//         )}

//         {/* Chapters, Topics, and Lessons */}
//         {showChapters && (
//           <div className="mt-5">
       
// {/* Streak, Tokens, and Insight Box */}
// {/* Streak, Tokens, and Insight Box */}
// <div style={{
//   backgroundColor: '#232830',
//   padding: '10px 20px',
//   borderRadius: '15px',
//   display: 'flex',
//   justifyContent: 'space-around',
//   alignItems: 'center',
//   width: '350px',  // Slightly wider for better spacing
//   margin: '20px auto'
// }}>

//   {/* Streak Icon 🔥 */}
//   <div style={{ display: 'flex', alignItems: 'center' }}>
//     <FaFire style={{ color: '#FF7C24', fontSize: '26px' }} />
//     <span style={{ color: '#FF7C24', fontSize: '22px', marginLeft: '5px' }}>{totalStreak.toString()}</span>
//   </div>

//   {/* Tokens Icon ₿ */}
//   <div style={{ display: 'flex', alignItems: 'center' }}>
//     <FaBitcoin style={{
//       backgroundColor: '#FF7C24',
//       color: '#fff',
//       padding: '5px',
//       borderRadius: '5px',
//       fontSize: '22px'
//     }} />
//     <span style={{ color: '#FF7C24', fontSize: '22px', marginLeft: '5px' }}>{totalTokens.toString()}</span>
//   </div>

//   {/* Insight Icon 📊 (Dynamically Updates) */}
//   <div style={{ display: 'flex', alignItems: 'center' }}>
//     <FaChartBar style={{ color: '#2ECC71', fontSize: '26px' }} />
//     <span style={{ color: '#2ECC71', fontSize: '22px', marginLeft: '5px' }}>{insightCount}</span>  {/* This dynamically updates */}
//   </div>

// </div>



// <h3>Chapters for {selectedCourse ? selectedCourse.coursename : "Selected Course"}:</h3>

//             {chapters.map((chapter) => (
//               <div key={chapter.chapterid} className="my-4">
//                 <Card className="mb-3" style={{ backgroundColor: '#222', color: '#fff', textAlign: 'center' }}>
//                   <Card.Body>
//                     <h5>{chapter.chaptername}</h5>
//                     <p>{chapter.chapterdescription}</p>
//                   </Card.Body>
//                 </Card>

//                 {/* Topics & Lessons */}
//                 {topics
//                   .filter((topic) => topic.chapterid === chapter.chapterid)
//                   .map((topic) => (
//                     <div key={topic.topicid} className="mb-4">
//                       {/* Topic Box with Larger Book Icon 📖 */}
//                       <Card className="p-2 text-center mx-auto" style={{ backgroundColor: '#FF7C24', color: '#fff', width: 'fit-content' }}>
//                         <Card.Body style={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}>
//                           <span>{topic.topicname}</span>
//                           <span style={{ marginLeft: '5px', fontSize: '12px', color: '#FFFFFF' }}>({topic.topicid})</span>
//                           <FaBookOpen
//   style={{ marginLeft: '10px', color: '#FFFFFF', fontSize: '24px', cursor: 'pointer' }}
//   onClick={() => handleShowLearningContent(topic.topicid)}
// />

//                         </Card.Body>
//                       </Card>

//                       {/* Unit & Quiz Lessons Below Topic */}
//                       {unitLessons[topic.topicid]?.map((unitLessonId) => (
//                         <div key={unitLessonId} className="text-center mt-2">
//                           <Button style={{ color: '#D63384', backgroundColor: 'transparent', border: 'none', fontWeight: 'bold', fontSize: '16px' }}>
//                             {unitLessonId}
//                           </Button>
//                           <div className="d-flex flex-column align-items-center">
//                             {generateQuizLessons(unitLessonId).map((quizLessonId) => (
//                               <Button key={quizLessonId} 
//                               onClick={() => handleLessonClick(quizLessonId)}  // ✅ Add this line to navigate to the quiz
//                               style={{ backgroundColor: '#232830', borderColor: '#232830', marginTop: '3px' }}>
//                                 {quizLessonId}
//                               </Button>
//                             ))}
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   ))}
//               </div>
//             ))}
//           </div>
//         )}
//       {/* Sliding Panel for Learning Content */}
// <Offcanvas show={showLearningContent} onHide={() => setShowLearningContent(false)} placement="end" style={{ backgroundColor: 'white', color: '#000' }}>
//   <Offcanvas.Header closeButton>
//     <Offcanvas.Title>Learning Content</Offcanvas.Title>
//   </Offcanvas.Header>
//   <Offcanvas.Body>
//     {/* Actions Section as Bullet Points */}
//     <h5>Actions:</h5>
//     <ul>
//       {Array.isArray(learningContent.actions) ? (
//         learningContent.actions.map((point, index) => <li key={index}>{point}</li>)
//       ) : (
//         String(learningContent.actions || 'No data available')
//           .split('. ')
//           .map((point, index) => <li key={index}>{point.trim()}</li>)
//       )}
//     </ul>

//     {/* Content Items Section as Bullet Points */}
//     <h5>Content Items:</h5>
//     <ul>
//       {Array.isArray(learningContent.contentitems) ? (
//         learningContent.contentitems.map((point, index) => <li key={index}>{point}</li>)
//       ) : (
//         String(learningContent.contentitems || 'No data available')
//           .split('. ')
//           .map((point, index) => <li key={index}>{point.trim()}</li>)
//       )}
//     </ul>

//     {/* Pro Tips Section as Bullet Points */}
//     <h5>Pro Tips:</h5>
//     <ul>
//       {Array.isArray(learningContent.protips) ? (
//         learningContent.protips.map((point, index) => <li key={index}>{point}</li>)
//       ) : (
//         String(learningContent.protips || 'No data available')
//           .split('. ')
//           .map((point, index) => <li key={index}>{point.trim()}</li>)
//       )}
//     </ul>
//   </Offcanvas.Body>
// </Offcanvas>
//       </Container>
//     </Layout>
//   );
// };

// export default WelcomePage;
